import { z } from 'zod';
import { addressLocationInputSchema } from '../address/create-pair-input.js';
/** The vendor pair's two locations, shared by the New Vendor pair and the Add Address pair so their shapes can't drift. */
export const vendorAddressPairLocationFields = {
    shipping: addressLocationInputSchema,
    remitSameAsShipping: z.boolean(),
    remit: addressLocationInputSchema.nullish(),
};
//# sourceMappingURL=pair-location-fields.js.map